import "./index.scss";

import { Modal, Stack } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import ScreenLoader from "components/ScreenLoader";
import SearchableGroupedList from "components/SearchableGroupedList";
import {
  getLkpCardioExercisesActivities,
  getLkpCardioExercisesClasses,
  getLkpCardioExercisesMachinesConnectedToFitlinxx,
  getLkpCardioExercisesMachinesNotConnectedToFitlinxx,
} from "modules/workout-plan/workoutPlanServices";
import { memo, useCallback, useEffect, useState } from "react";

const CardioProgramExerciseSelector = (props: {
  open: boolean;
  onClose: any;
  selectedExercises: any[];
}) => {
  const { open, onClose, selectedExercises } = props;
  const [loading, setLoading] = useState(false);
  const [lookupsLoaded, setLookupsLoaded] = useState(false);
  const [cardioExercisesList, setCardioExercisesList] = useState([]);

  //Preparing data needed
  useEffect(() => {
    if (open && !lookupsLoaded) {
      setLoading(true);
      let promises: Promise<any>[] = [];
      let cardioExercises = [
        {
          label: "Activities",
          options: [],
        },
        {
          label: "Machines connected to FitLinxx",
          options: [],
        },
        {
          label: "Machines not connected to FitLinxx",
          options: [],
        },
        {
          label: "Classes",
          options: [],
        },
      ];

      //Get list activities
      promises.push(
        getLkpCardioExercisesActivities({
          sort_by: "NAME",
          sort_order: "ASC",
        }).then((res) => {
          if (res.success) {
            cardioExercises.find((e) => e.label === "Activities").options = res.data.map((e) => ({
              label: e.name,
              type: e.type,
              value: e.id,
            }));
          }
        })
      );

      //Get list machines connected to fitlinxx
      promises.push(
        getLkpCardioExercisesMachinesConnectedToFitlinxx({
          sort_by: "NAME",
          sort_order: "ASC",
        }).then((res) => {
          if (res.success) {
            cardioExercises.find((e) => e.label === "Machines connected to FitLinxx").options =
              res.data.map((e) => ({
                label: e.name,
                type: e.type,
                value: e.id,
              }));
          }
        })
      );

      //Get list machines not connected to fitlinxx
      promises.push(
        getLkpCardioExercisesMachinesNotConnectedToFitlinxx({
          sort_by: "NAME",
          sort_order: "ASC",
        }).then((res) => {
          if (res.success) {
            cardioExercises.find((e) => e.label === "Machines not connected to FitLinxx").options =
              res.data.map((e) => ({
                label: e.name,
                type: e.type,
                value: e.id,
              }));
          }
        })
      );

      //Get list classes
      promises.push(
        getLkpCardioExercisesClasses({
          sort_by: "NAME",
          sort_order: "ASC",
        }).then((res) => {
          if (res.success) {
            cardioExercises.find((e) => e.label === "Classes").options = res.data.map((e) => ({
              label: e.name,
              type: e.type,
              value: e.id,
            }));
          }
        })
      );

      Promise.all(promises).then((_v) => {
        setCardioExercisesList(cardioExercises);
        setLoading(false);
        setLookupsLoaded(true);
      });
    }
  }, [open]);

  //#region event handlers
  const handleCloseModal = useCallback(() => {
    onClose();
  }, []);
  //#endregion event handlers

  return (
    <Modal
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      open={open}
      onClose={handleCloseModal}
    >
      <Stack className="personal-details-modal-container cardio-program-exercise-selector">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          marginBottom="40px"
          className="header"
        >
          <h1>Add/Edit Exercises, Machines and Classes</h1>
          <DeleteIcon width="24px" height="24px" onClick={handleCloseModal} />
        </Stack>
        {loading && <ScreenLoader isScreenLoader />}
        {!loading && (
          <SearchableGroupedList
            options={cardioExercisesList}
            preselectedValues={selectedExercises}
            callback={(v) => onClose(v)}
          />
        )}
      </Stack>
    </Modal>
  );
};

export default memo(CardioProgramExerciseSelector);
